// Temperature
// Convert Kelvin to Fahrenheit.

const kToF = (k: number) => (k >= 0 ? Math.round((k - 273.15) * (9 / 5) + 32) : null);

// Speed
// Convert meters per second to miles per hour.

const mpsToMPH = (mps: number) => (mps >= 0 ? Math.round(mps * 2.236936) : null);

// Export structure

// Provide a structure for unit conversions.  Each unit type should be a top-level key.
// Conversions within each type should be included at the second level.

export const Units = {
  temperature: {
    kToF,
  },
  speed: {
    mpsToMPH,
  },
};
